import { ApartmentCountLimitsPort } from '../../ports/ApartmentCountLimitsPort';

export class ApartmentCountLimitUseCase {
  constructor(private readonly apartmentCountLimitsPort: ApartmentCountLimitsPort) {}

  getMin(): number {
    return this.apartmentCountLimitsPort.getMin();
  }

  getMax(): number {
    return this.apartmentCountLimitsPort.getMax();
  }
}
